import ForgotPassword from "../../pages/onboarding/component/forgot-password";

//development uat
export const baseUrl = "https://bizprime.web.bigcityvoucher.co.in";

export const ApiConfiguration = {
	register: baseUrl + "/api/register",
	verifyOtp: baseUrl + "/api/otp_verify",
	login: baseUrl + "/api/login",
	sendOtp: baseUrl + "/api/send_otp",
	forgotPassword: baseUrl + "/api/forget_password",
	membershipList: baseUrl + "/api/get-membership",
	purchaseMembership: baseUrl + "/api/membership_puchase",
	dashbaord: baseUrl + "/api/dashboard",
	productList: "/api/get_product",
	productDetail: "/api/get_product_details",
	claimProduct: "/api/offer-claim",

	// dashboard: baseUrl + '/customer/dashboard',
	offerDetail: baseUrl + "/product/product-detail",
	getProductByCat: baseUrl + "/product/product_by_categoriy",
	categories: baseUrl + "/product/categories",
	otp: baseUrl + "/customer/verify-otp",
	banner: baseUrl + "/customer/banner",
	claimOffer: baseUrl + "/orders/claim-uniquecode",
	getMembershipDetail: baseUrl + "/customer/get-membership-detail",
	claimMembership: baseUrl + "/customer/claim-memebership",
	checkValidMember: baseUrl + "/customer/check-valid-membership",
	orderHistory: baseUrl + "/orders/order-history",
	customerDetail: baseUrl + "/customer/cutomer-detail",
	editUserDetail: baseUrl + "/customer/update-customer-detail",

	// CategoryList
	categoryList: baseUrl + "/api/get_category",

	// ProfileDetails

	userProfileDetails: baseUrl + "/api/get_profile",
	orderDetails: baseUrl + "/api/get_order_details",
	savingsDetails: baseUrl + "/api/get_savings_details",

	// Terms And Condition
	getTermsAndCondition: baseUrl + "/api/get_content",

	// Contact Us
	contactus: baseUrl + "/api/contact_us",

	// subscription invoice details
	subscriptionInvoiceDetails: baseUrl + "/api/get_invoice_subscription",

	// orderInvoiceDetails
	orderInvoiceDetails: baseUrl + "/api/get_invoice_order",
};
